import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import {
  setUserOnboardingProgress,
  setUserOnboardingProgressLoading,
  store,
} from "..";

export const getUserOnboardingProgress = async (notify: MessageInstance) => {
  try {
    store.dispatch(setUserOnboardingProgressLoading(true));
    const response = await privateAPI.get("/onboarding/progress/all");
    if (response) {
      store.dispatch(setUserOnboardingProgressLoading(false));
      store.dispatch(setUserOnboardingProgress(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setUserOnboardingProgressLoading(false));
    console.error("Get User Onboarding Progress Error:", error);
    errorHandler(error, notify);
  }
};
